import { ErrorState } from "@idw-types/state";
import { ErrorActions, ErrorActionTypes } from "../actions/error-actions";
import { RootActions, RootActionTypes } from "../actions/root-actions";

export const initialErrorState: ErrorState = {
    asi: null,
    name: null,
    errorCode: null,
    message: null,
    httpStatus: null,
    errorURI: null,
    language: null
};

export const errorReducer = (
    state: ErrorState = initialErrorState,
    action: ErrorActions | RootActions
) => {
    switch (action.type) {
        case ErrorActionTypes.SET_ERROR:
            return {
                ...state,
                ...action.payload.error
            };
        case RootActionTypes.RESET_STATE:
            return { ...initialErrorState };
        default:
            return state;
    }
};